import { Calendar } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import NotificationPanel from "./NotificationPanel";

export default function Header() {
  const { user } = useAuth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <header
      className="sticky top-0 z-30 w-full border-b border-white/10 px-6 py-3 flex items-center justify-between"
      style={{ background: "rgba(10,10,10,0.8)", backdropFilter: "blur(16px)" }}
      data-testid="dashboard-header"
    >
      <div>
        <h1
          className="text-xl font-black text-white tracking-tight"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
        >
          Master Admin Axis
        </h1>
        <div className="flex items-center gap-1.5 mt-0.5">
          <Calendar size={12} className="text-[#A1A1AA]" />
          <span className="text-xs text-[#A1A1AA]">{dateStr}</span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <NotificationPanel />
        <div className="flex items-center gap-2">
          {user?.picture ? (
            <img src={user.picture} alt="" className="w-8 h-8 rounded-full border border-white/10" />
          ) : (
            <div className="w-8 h-8 rounded-full bg-white/10" />
          )}
          <div className="hidden md:block">
            <p className="text-sm text-white leading-tight">{user?.name}</p>
            <p className="text-[10px] text-[#00E5FF] uppercase tracking-wider">
              {user?.role === "master_admin" ? "Master" : "Slave"} Axis
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
